import { render } from "./WatchOnDevice.vue?vue&type=template&id=2bbfc71e&scoped=true"
import script from "./WatchOnDevice.vue?vue&type=script&lang=js"
export * from "./WatchOnDevice.vue?vue&type=script&lang=js"

import "./WatchOnDevice.vue?vue&type=style&index=0&id=2bbfc71e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bbfc71e"]])

export default __exports__